// store/auth.ts
import { create } from "zustand"
import { persist } from "zustand/middleware"

import { LoginUser } from "../data/model/response/loginDtoResponse"

interface AuthState {
    token?: string
    user?: LoginUser
    isLoggedIn: boolean
    login: (token: string, user: LoginUser) => void
    logout: () => void
}

export const useAuthStore = create<AuthState>()(
    persist(
        (set) => ({
            token: undefined,
            user: undefined,
            isLoggedIn: false,
            login: (token, user) =>
                set({ token, user, isLoggedIn: true }),
            logout: () =>
                set({ token: undefined, user: undefined, isLoggedIn: false }),
        }),
        { name: "auth-storage" }
    )
)
